import React, { useState } from 'react';
import TauriSectionModalVisual from '../../TauriSectionBaseVisual/TauriSectionModalVisual/TauriSectionModalVisual';
import TauriSectionModalMultiVisual from '../../TauriSectionBaseVisual/TauriSectionModalMultiVisual/TauriSectionModalMultiVisual';
import setting from '../../../config.json';
import OpalAccordionItem from '../../OpalAccordionItem/OpalAccordionItem';
import './OpalForApprovalVisual.css';
import ApprovedLeaveModal from './ApprovedLeaveModal/ApprovedLeaveModal';
import { useNavigate } from 'react-router-dom';
import MissedCallApprovalModal from './MissedCallApprovalModal/MissedCallApprovalModal';

const OpalForApprovalVisual = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {
    const [selectedVisual, setSelectedVisual] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });
    const [search, setSearch] = useState('');
    const [selectedCard, setSelectedCard] = useState(null);
    const [showLeaveModal, setShowLeaveModal] = useState(false);
    const [showMissedCallModal, setShowMissedCallModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const navigate = useNavigate();

    const handleDataPointSelection = (event) => {
        const title = chartConfig.binding.context.point.onClick.selectedValueColumn;
        const modalTitle = chartConfig.binding.context.point.onClick.selectedTitle;
        const selectedDesc = chartData[0][chartConfig.binding.data.title];
        const selectedVal = chartData[0][title];
        const selectedTitle = chartConfig.title;

        if (chartConfig.binding.context.point.onClick.visual || Array.isArray(chartConfig.binding.context.point.onClick.visuals)) {
            let selectedVisual = null;
            if (chartConfig.binding.context.point.onClick.visuals) {
                selectedVisual = chartConfig.binding.context.point.onClick.visuals;
            } else {
                selectedVisual = chartConfig.binding.context.point.onClick.visual;
            }

            setSelectedVisual(selectedVisual);
            setSelectedData({ title, selectedDesc, selectedVal, selectedTitle, modalTitle });

            const tauriElement = document.querySelector('.tauri-host-container');
            if (tauriElement) {
                if (event) {
                    let posX = event.clientX;
                    let posY = event.clientY;
                    if ((event.clientX + setting.modalMinWidth) > window.innerWidth) {
                        posX = event.clientX - setting.modalMinWidth;
                    }
                    if ((event.clientY + setting.modalMinHeight) > window.innerHeight) {
                        posY = event.clientY - setting.modalMinHeight;
                    }

                    setModalPosition({ x: posX, y: posY });
                }
            }
        }
    };

    const handleSelect = (item) => {
        setSelectedItem(item);
        if (item?.Type === 'Plan') {
            navigate(`/planning/${item.ID}`)
        } else if (item?.Type === 'Leave') {
            setShowLeaveModal(true);
        } else if (item?.Type === 'MissedCall') {
            setShowMissedCallModal(true);
        } else {
            setShowLeaveModal(true);
        }
    }

    const data = [
        { ID: 44, Description: "Coverage Plan - Cycle 9", Name: "Argie Brul", Type: "Plan" },
        { ID: 2, Description: "Coverage Plan - Cycle 10", Name: "Mark Resma Dacurawat", Type: "Plan" },
        { ID: 3, Description: "Coverage Plan - Cycle 8", Name: "Mcvageau Sajulan", Type: "Plan" },
        { ID: 4, Description: "VL - Sept 3, 2025", Name: "Mcvageau Sajulan", Type: "Leave" },
        { ID: 5, Description: "Missed Calls - Cycle 7", Name: "Mcvageau Sajulan", Type: "MissedCall" },
        { ID: 6, Description: "New Customers - Aug 1 to 7, 2025", Name: "Rae Anne Camille Inoc", Type: "NewCustomer" }
    ];

    return (
        <>
            <div className='chart-content' >
                <OpalAccordionItem
                    items={data}
                    search={search}
                    onSelectItem={handleSelect}
                    type={"v5"}
                    selectedCard={selectedCard}
                    setSelectedCard={setSelectedCard}
                />
            </div>
            {selectedVisual && (
                chartConfig.binding.context.point.onClick.visuals ? (
                    <TauriSectionModalMultiVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                ) : (
                    <TauriSectionModalVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                )
            )}
            <ApprovedLeaveModal show={showLeaveModal} onHide={() => setShowLeaveModal(false)} item={selectedItem} />
            <MissedCallApprovalModal show={showMissedCallModal} onHide={() => setShowMissedCallModal(false)} item={selectedItem} />
        </>
    );
};

export default OpalForApprovalVisual;
